module.exports = __webpack_public_path__ + "img/icon-europe.637d4723.svg";